import { toast, ToastId } from 'react-toastify';
import { StringKey } from '../../Locales/fr';
import { I18n } from '../../Locales/I18nService';

import { CustomToast, CustomToastType } from '../Components/Views/CustomToast/CustomToast';
import { DatadogWrapper } from '../../Plugins/Datadog/DatadogWrapper';

export type ToastParams = {
    title?: string;
    content: string;
    duration?: number;
    copyContent?: string;
    copyDisabled?: boolean;
    classes?: { root?: string };
};
export class Toast {
    public static showSuccess(toastParams: ToastParams): ToastId {
        const { duration, classes, ...props } = toastParams;
        return toast.success(CustomToast({ type: CustomToastType.SUCCESS, ...props }), {
            autoClose: duration,
            className: classes?.root,
        });
    }

    public static showError(toastParams: ToastParams): ToastId {
        const { duration, ...props } = toastParams;
        const toastId = toast.error(CustomToast({ type: CustomToastType.ERROR, ...props }), { autoClose: duration });
        DatadogWrapper.RUM.addError(new Error(props.content));
        return toastId;
    }

    public static showInfo(toastParams: ToastParams): ToastId {
        const { duration, ...props } = toastParams;
        return toast.error(CustomToast({ type: CustomToastType.INFO, ...props }), { autoClose: duration });
    }

    public static success = (messageId: StringKey) => Toast.showSuccess({ content: I18n.get(messageId) });
    public static error = (messageId: StringKey) => Toast.showError({ content: I18n.get(messageId) });

    public static notImplemented = () =>
        toast.success(
            CustomToast({ type: CustomToastType.INFO, title: 'Not implemented', content: 'Revenez la prochaine fois' })
        );
}
